import { createSlice } from '@reduxjs/toolkit';

const initialState = {
     events: [],
     eventDetails: null,
     loading: false,
     error: null,
     registering: false,
     registerError: null,
     purchaseResponse: null,
};

const eventSlice = createSlice({
     name: 'events',
     initialState,
     reducers: {
          fetchEventsRequest(state) {
               state.loading = true;
               state.error = null;
          },
          fetchEventsSuccess(state, action) {
               state.loading = false;
               state.events = action.payload;
          },
          fetchEventsFailure(state, action) {
               state.loading = false;
               state.error = action.payload;
          },
          fetchEventDetailsRequest(state) {
               state.loading = true;
               state.error = null;
          },
          fetchEventDetailsSuccess(state, action) {
               state.loading = false;
               state.eventDetails = action.payload;
          },
          fetchEventDetailsFailure(state, action) {
               state.loading = false;
               state.error = action.payload;
          },
          registerEventRequest(state) {
               state.registering = true;
               state.registerError = null;
               state.purchaseResponse = null;
          },
          registerEventSuccess(state, action) {
               state.registering = false;
               state.purchaseResponse = action.payload;
          },
          registerEventFailure(state, action) {
               state.registering = false;
               state.registerError = action.payload;
          },
          clearRegisterState(state) {
               state.registering = false;
               state.registerError = null;
               state.purchaseResponse = null;
          },
     },
});

export const {
     fetchEventsRequest,
     fetchEventsSuccess,
     fetchEventsFailure,
     fetchEventDetailsRequest,
     fetchEventDetailsSuccess,
     fetchEventDetailsFailure,
     registerEventRequest,
     registerEventSuccess,
     registerEventFailure,
     clearRegisterState,
} = eventSlice.actions;

export const eventReducer = eventSlice.reducer;
